function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("stimulus")) : "function" == typeof define && define.amd ? define(["stimulus"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.stimulusDataBindings = e(require("stimulus")) : t.stimulusDataBindings = e(t.Stimulus);
}(window, function (t) {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 6);
  }([function (t, e) {
    function n(e) {
      return t.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, n(e);
    }
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    t.exports = function (t, e, r) {
      return e && n(t.prototype, e), r && n(t, r), t;
    };
  }, function (t, e, n) {
    var r = n(7);
    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && r(t, e);
    };
  }, function (t, e, n) {
    var r = n(8),
      o = n(9);
    t.exports = function (t, e) {
      return !e || "object" !== r(e) && "function" != typeof e ? o(t) : e;
    };
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "DataBindingController", function () {
      return b;
    });
    var r = n(1),
      o = n.n(r),
      i = n(2),
      u = n.n(i),
      a = n(3),
      f = n.n(a),
      c = n(4),
      l = n.n(c),
      s = n(0),
      y = n.n(s),
      d = n(5);
    function p(t, e) {
      var _n;
      if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
        if (Array.isArray(t) || (_n = function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return v(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === n && t.constructor && (n = t.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(t);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return v(t, e);
        }(t)) || e && t && "number" == typeof t.length) {
          _n && (t = _n);
          var r = 0,
            o = function o() {};
          return {
            s: o,
            n: function n() {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function e(t) {
              throw t;
            },
            f: o
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var i,
        u = !0,
        a = !1;
      return {
        s: function s() {
          _n = t[Symbol.iterator]();
        },
        n: function n() {
          var t = _n.next();
          return u = t.done, t;
        },
        e: function e(t) {
          a = !0, i = t;
        },
        f: function f() {
          try {
            u || null == _n["return"] || _n["return"]();
          } finally {
            if (a) throw i;
          }
        }
      };
    }
    function v(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }
    function h(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = y()(t);
        if (e) {
          var o = y()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return l()(this, n);
      };
    }
    var b = function (t) {
      f()(n, t);
      var e = h(n);
      function n() {
        return o()(this, n), e.apply(this, arguments);
      }
      return u()(n, [{
        key: "connect",
        value: function value() {
          var t,
            e = p(this.containerTarget.querySelectorAll("[data-binding-type]"));
          try {
            for (e.s(); !(t = e.n()).done;) {
              var n = t.value;
              this._runBindings(n);
            }
          } catch (t) {
            e.e(t);
          } finally {
            e.f();
          }
        }
      }, {
        key: "update",
        value: function value(t) {
          this._runBindings(t.currentTarget);
        }
      }, {
        key: "bind",
        value: function value(t) {
          var e,
            n = t.value,
            r = (t.dataset.to, p(this._bindingElements(t.dataset.to)));
          try {
            for (r.s(); !(e = r.n()).done;) {
              var o = e.value;
              this._setValue(o, n);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
          return !0;
        }
      }, {
        key: "showIfChecked",
        value: function value(t) {
          var e,
            n = t.checked,
            r = p(this._bindingElements(t.dataset.show));
          try {
            for (r.s(); !(e = r.n()).done;) {
              var o = e.value;
              this._toggleElement(o, n);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
          return !0;
        }
      }, {
        key: "showIfValue",
        value: function value(t) {
          var e,
            n = t.value,
            r = p(this._bindingElements(t.dataset.show));
          try {
            for (r.s(); !(e = r.n()).done;) {
              var o = e.value;
              this._toggleElement(o, o.dataset.showValue == n);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
          return !0;
        }
      }, {
        key: "hideIfChecked",
        value: function value(t) {
          var e,
            n = t.checked,
            r = p(this._bindingElements(t.dataset.hide));
          try {
            for (r.s(); !(e = r.n()).done;) {
              var o = e.value;
              this._toggleElement(o, !n);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
        }
      }, {
        key: "hideIfBlank",
        value: function value(t) {
          var e,
            n = "" == t.value,
            r = p(this._bindingElements(t.dataset.hide));
          try {
            for (r.s(); !(e = r.n()).done;) {
              var o = e.value;
              this._toggleElement(o, !n);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
        }
      }, {
        key: "_runBindings",
        value: function value(t) {
          var e,
            n = p(t.dataset.bindingType.split(" "));
          try {
            for (n.s(); !(e = n.n()).done;) {
              this[e.value](t);
            }
          } catch (t) {
            n.e(t);
          } finally {
            n.f();
          }
        }
      }, {
        key: "_setValue",
        value: function value(t, e) {
          t.textContent = e;
        }
      }, {
        key: "_toggleElement",
        value: function value(t, e) {
          return e ? t.removeAttribute("hidden") : t.setAttribute("hidden", "hidden"), !0;
        }
      }, {
        key: "_bindingElements",
        value: function value(t) {
          return this.containerTarget.querySelectorAll('[data-binding-ref="'.concat(t, '"]'));
        }
      }]), n;
    }(d.Controller);
    b.targets = ["container"];
  }, function (t, e) {
    function n(e, r) {
      return t.exports = n = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, n(e, r);
    }
    t.exports = n;
  }, function (t, e) {
    function n(e) {
      return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? t.exports = n = function n(t) {
        return _typeof(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, n(e);
    }
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }]);
});